var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  fillRule: "evenodd",
  d: "M12 2.4c2.441 0 4.42 1.348 4.42 5.071 0 2.8-1.979 5.071-4.42 5.071s-4.42-2.27-4.42-5.071C7.58 3.748 9.558 2.4 12 2.4m3.178 10.357c.26.043.397.076.397.076 6.489 1.565 6.017 7.496 6.017 7.496s-9.711 2.859-19.184 0c0 0-.471-5.924 6.005-7.493.298.738 1.692 1.296 3.37 1.296 1.737 0 3.168-.599 3.395-1.375",
  clipRule: "evenodd"
})));
export default SvgUser;